import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Paper, Stack, Typography, useTheme, Collapse, IconButton } from "@mui/material";
import CopyableTypography from "components/Typography/CopyableTypography";
import { ActivityType } from "generated-graphql/graphql";
import { useLocalStorageState } from "hooks/useLocalStorageState";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useFulfillmentDetails } from "../useFulfillmentDetails";
import { getRelevantPortalCredential } from "../useRelevantPortalCredential";
import { buildGeppettoCommand, getGeppettoAction } from "./geppettoCommandUtils";

const GeppettoCommand = () => {
  const theme = useTheme();
  const { data } = useFulfillmentDetails();
  const { activityId } = useParams();
  const [isExpanded, setIsExpanded] = useLocalStorageState<boolean>(
    "fulfillment-geppetto-command-expanded",
    { defaultValue: true }
  );

  const viewingActivity = data?.tierIIReport.currentWorkflow?.activities.find(
    (a) => a.id === activityId
  );

  const isViewingGeppettoActivity =
    viewingActivity?.type === ActivityType.Geppetto ||
    viewingActivity?.type === ActivityType.CollectEvidence;

  const action = getGeppettoAction(
    viewingActivity?.type,
    viewingActivity?.currentJob?.action,
    viewingActivity?.description,
    data?.tierIIReport.reportKind
  );

  const facilityId = data?.tierIIReport.facility.id;

  const reportKind = data?.tierIIReport.reportKind;

  const jobId = viewingActivity?.currentJob?.id;

  const relevantCredential = getRelevantPortalCredential(
    data?.tierIIReport.facility?.portalCredentials,
    viewingActivity
  );
  const credentialId = relevantCredential?.credential?.id;

  const reportId = data?.tierIIReport.id;

  const geppettoCommand = useMemo(() => {
    return buildGeppettoCommand({
      action,
      reportingYear: data?.tierIIReport.reportingYear,
      reportKind,
      facilityId,
      jobId,
      credentialId,
      reportId,
    });
  }, [
    action,
    facilityId,
    reportKind,
    jobId,
    credentialId,
    reportId,
    data?.tierIIReport.reportingYear,
  ]);

  if (!isViewingGeppettoActivity) return <></>;

  return (
    <Stack direction={"column"} component={Paper} elevation={0} sx={{ padding: theme.spacing(3) }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Typography variant="h6">Geppetto Command</Typography>
        <IconButton size="small" sx={{ ml: 1 }}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={isExpanded}>
        <Box sx={{ mt: 3 }}>
          <CopyableTypography text={geppettoCommand} />
        </Box>
      </Collapse>
    </Stack>
  );
};

export { GeppettoCommand };
